module.exports = __webpack_public_path__ + "img/logo.dbd82ab0.png";